<div class="panel-tabs">
    <nav>
        <ul class="nav nav-pills">
            <li *ngIf="tabsEnabled.indexOf('control')>-1" [routerLinkActive]="['active']">
                <a [routerLink]="['./control']" translate>CONTRACT_INTERNAL_CONTROL</a>
            </li>
        </ul>
    </nav>
</div>
<router-outlet></router-outlet>